import { useEffect } from 'react';
import firebase from '../../firebase';

const useAnalytics = (groupId) => {
    useEffect(() => {
        if (groupId) {
            firebase.analytics().setUserProperties({ group_id: groupId });
        }
    }, [groupId]);

    useEffect(() => {
        const currentUser = firebase.auth().currentUser;
        if (currentUser) {
            firebase.analytics().setUserId(currentUser.uid);
        }
    }, []);
};

export default useAnalytics;
